import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType, ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmTableTd',
  props: {
  /**
   * Отключить или включить бордер слева ячейки
   */
  isLeftBorder: { type: Boolean as PropType<Boolean>, default: true },
},
  setup(__props) {

const props = __props;

const $el = ref<HTMLElement>();



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["table-grid-td", { 'table-grid-td--left-border': props.isLeftBorder }]),
    ref_key: "$el",
    ref: $el
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})